import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { selectedPairsToObjectives } from '@shared/mappers/investment-objectives/selected-pairs-to-objectives';
import {
  TransformObjectivesFromUi,
  UpdateInvestmentObjectives,
} from '@store/actions/investment-objectives/investment-objectives.action';
import { map } from 'rxjs/operators';

@Injectable()
export class InvestmentObjectivesEffects {
  transformFromUi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TransformObjectivesFromUi),
      map(({ payload }) => {
        const objectives = selectedPairsToObjectives(payload.selectedObjectives || []);
        // We only persist booleans; do not store status in NgRx
        return UpdateInvestmentObjectives({ objectives });
      }),
    ),
  );

  constructor(private actions$: Actions) {}
}
